import {Outlet} from "react-router-dom";
import {useContext} from "react";
import {UserContext} from "../../../hooks/Context/UserContext";
import {PermissionType} from "../../../constants/types/PermissionType";

const AssessmentsSuperAdminLayout = () => {
  const [user] = useContext(UserContext);

  if (user.permission_groups?.includes(PermissionType.cpl_super_admin)) {
    return <Outlet/>;
  }

  return null;
}

export default AssessmentsSuperAdminLayout;